export default __webpack_public_path__ + "static/media/total-user.a560a920.svg";